import { Dialog } from '@headlessui/react';
import React from 'react'
import ImageUploadButton from '../../utils/buttons/imageUploadButton';
import { InputFields } from '../../InputField/InputFIelds';
import SelectBox from '../../Common/componets/SelectBox';
import { icons8crossFilled } from '../../../assets';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '../../utils/buttons/primaryButton';
import CreatableSelect from 'react-select/creatable';
import { useQuery } from 'react-query';
import { getAllYears } from '../../../utility/api';


const EditAddModal = ({
     handleColorChange, 
     error, 
     isUnique,
      imageRefs, 
      loading, 
      open, 
      setOpen, 
      setFormData, 
      formData, 
      handleInputChange, 
      handleOnSUbmit,
      edit=false
     }) => {
    const { t } = useTranslation();
    const {data, isLoading} = useQuery({queryFn: ["getYear"], queryFn: getAllYears})
    const colorOptions = [
        {
            value: "Black",
            label: t("usedCars.colors.black")
        }, {
            value: "White",
            label: t("usedCars.colors.white")
        }, {
            value: "Red",
            label: t("usedCars.colors.red")
        }, {
            value: "Blue",
            label: t("usedCars.colors.blue")
        },
    ];
    
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            className="relative z-50"
        >
            <div className="fixed inset-0 bg-black/30 flex items-center justify-center p-4 ">
                <Dialog.Panel className="w-full max-w-5xl rounded bg-white p-4 max-h-[100vh]">
                    <div className="pb-2">
                        <img
                            src={icons8crossFilled}
                            onClick={() => setOpen(false)}
                            className="w-8 h-8 cursor-pointer ml-auto"
                        />
                    </div>

                    <div className="overflow-auto no-scrollbar w-full max-h-[75vh] p-1">
                        <div className="flex items-center my-4">
                            <hr className="flex-grow border-t border-muted border-black" />
                            <span className="mx-4 text-muted-foreground font-semibold text-xl">
                                {t("usedCars.uploadImage")}
                            </span>
                            <hr className="flex-grow border-t border-muted border-black" />
                        </div>

                        <div className="flex gap-5">
                            <ImageUploadButton
                                stateData={formData?.front}
                                setStateData={(value) => {
                                    console.log(value);

                                    setFormData({ ...formData, front: value })
                                }
                                }
                                refData={imageRefs?.front}
                                view={t("usedCars.frontImage")}
                            />
                            <ImageUploadButton
                                stateData={formData.back}
                                setStateData={(value) =>
                                    setFormData({ ...formData, back: value })
                                }
                                refData={imageRefs?.back}
                                view={t("usedCars.backImage")}
                            />
                            <ImageUploadButton
                                stateData={formData.left}
                                setStateData={(value) =>
                                    setFormData({ ...formData, left: value })
                                }
                                refData={imageRefs?.left}
                                view={t("usedCars.leftImage")}
                            />
                            <ImageUploadButton
                                stateData={formData.right}
                                setStateData={(value) =>
                                    setFormData({ ...formData, right: value })
                                }
                                refData={imageRefs?.right}
                                view={t("usedCars.rightImage")}
                            />
                        </div>

                        <div>
                            <div >
                                <div className="flex items-center my-4">
                                    <hr className="flex-grow border-t border-muted border-black" />
                                    <span className="mx-4 text-muted-foreground font-semibold text-xl">
                                        {t("usedCars.overview")}
                                    </span>
                                    <hr className="flex-grow border-t border-muted border-black" />
                                </div>

                                <div className="grid grid-cols-3 gap-5 mt-5">
                                    <div>
                                        <InputFields
                                            type="text"
                                            title={t("usedCars.vin")}
                                            placeholder={t("usedCars.form.placeholders.vin")}
                                            value={formData?.vin}
                                            name="vin"
                                            onChange={handleInputChange}
                                        />

                                        {edit ? !isUnique?.unique && !isUnique?.sameUser    && (
                                            <p className="mt-2" style={{ color: "red" }}>
                                                {t("usedCars.validation.vinAlreadyRegistered")}
                                            </p>
                                        ):  !isUnique?.unique && (
                                            <p className="mt-2" style={{ color: "red" }}>
                                                {t("usedCars.validation.vinAlreadyRegistered")}
                                            </p>)}
                                        {isUnique?.unique === true && (
                                            <p className="mt-2" style={{ color: "green" }}>
                                                {t("usedCars.messages.vinAvailable")}
                                            </p>
                                        )}
                                        {error && <p style={{ color: "red" }}>{t(error)}</p>}
                                    </div>

                                    <InputFields
                                        type="text"
                                        title={t("usedCars.carName")}
                                        placeholder={t("usedCars.form.placeholders.carName")}
                                        value={formData?.overview?.carName}
                                        name="overview.carName"
                                        onChange={handleInputChange}
                                    />
                                    <InputFields
                                        type="number"
                                        title={t("usedCars.price")}
                                        placeholder={t("usedCars.form.placeholders.price")}
                                        value={formData?.overview?.price}
                                        name="overview.price"
                                        onChange={handleInputChange}
                                        min={0}
                                        step={1}
                                        onKeyDown={(e) => {
                                            if (e.code === "Minus") {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <div>
                                        <label className="mb-1 text-sm font-medium">
                                            {t("usedCars.labels.engineType")}
                                        </label>
                                        <div className="flex flex-row mt-1">
                                            <SelectBox
                                                options={[
                                                    { value: "V engine", label: t("usedCars.options.engineType.vEngine") },
                                                    { value: "Inline engine", label: t("usedCars.options.engineType.inlineEngine") },
                                                    { value: "Rotary engine", label: t("usedCars.options.engineType.rotaryEngine") },
                                                    { value: "Diesel engine", label: t("usedCars.options.engineType.dieselEngine") },
                                                    { value: "Hybrid engine", label: t("usedCars.options.engineType.hybridEngine") },
                                                    { value: "W engine", label: t("usedCars.options.engineType.wEngine") },
                                                    { value: "External combustion engine", label: t("usedCars.options.engineType.externalCombustion") },
                                                ]}
                                                onChange={handleInputChange}
                                                value={formData?.overview?.engineType}
                                                placeholder={t("usedCars.select.engineType")}
                                                name="overview.engineType"
                                            />

                                        </div>
                                    </div>
                                    <InputFields
                                        type="number"
                                        title={t("usedCars.drivenKm")}
                                        placeholder={t("usedCars.form.placeholders.drivenKm")}
                                        value={formData?.overview?.drivenKm}
                                        name="overview.drivenKm"
                                        onChange={handleInputChange}
                                        min={0}
                                        step={1}
                                        onKeyDown={(e) => {
                                            if (e.code === "Minus") {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    {/* <InputFields
                              type="number"
                              title={t("usedCars.makeYear")}
                              placeholder={t("usedCars.form.placeholders.makeYear")}
                              value={formData?.overview?.makeYear}
                              name="overview.makeYear"
                              onChange={handleInputChange}
                              min={0}
                              step={1}
                              onKeyDown={(e) => {
                                if (e.code === "Minus") {
                                  e.preventDefault();
                                }
                              }}
                            /> */}
                                    <div>
                                        <label className="mb-1 text-sm font-medium">
                                            {t("usedCars.makeYear")}
                                        </label>
                                        <div className="flex flex-row mt-1">
                                            <SelectBox
                                                options={data ? data.map((item) => ({ value: item, label: item })) : []}
                                                onChange={handleInputChange}
                                                value={formData?.overview?.makeYear}
                                                placeholder={t("usedCars.form.placeholders.makeYear")}
                                                name="overview.makeYear"
                                            />

                                        </div>
                                    </div>
                                    <div>
                                        <label className="mb-1 text-sm font-medium">
                                            {t("usedCars.registrationYear")}
                                        </label>
                                        <div className="flex flex-row mt-1">
                                            <SelectBox
                                                options={data ? data.map((item) => ({ value: item, label: item })) : []}
                                                onChange={handleInputChange}
                                                value={formData?.overview?.registrationYear}
                                                placeholder={t("usedCars.form.placeholders.registrationYear")}
                                                name="overview.registrationYear"
                                            />

                                        </div>
                                    </div>
                                    {/* <InputFields
                              type="number"
                              title={t("usedCars.registrationYear")}
                              placeholder={t(
                                "usedCars.form.placeholders.registrationYear"
                              )}
                              value={formData?.overview?.registrationYear}
                              name="overview.registrationYear"
                              onChange={handleInputChange}
                              min={0}
                              step={1}
                              onKeyDown={(e) => {
                                if (e.code === "Minus") {
                                  e.preventDefault();
                                }
                              }}
                            /> */}
                                    <div>
                                        <label className="mb-1 text-sm font-medium">
                                            {t("usedCars.labels.transmission")}
                                        </label>
                                        <div className="flex flex-row mt-1">
                                            <SelectBox
                                                options={[
                                                    { value: "Automatic", label: t("usedCars.options.transmission.automatic") },
                                                    { value: "Manual", label: t("usedCars.options.transmission.manual") },
                                                ]}
                                                onChange={handleInputChange}
                                                value={formData?.overview?.transmission}
                                                placeholder={t("usedCars.select.transmission")}
                                                name="overview.transmission"
                                            />
                                            {/* <select
                                  name="overview.transmission"
                                  value={formData?.overview?.transmission}
                                  onChange={handleInputChange}
                                  className=" border-[1px] w-full h-[49px] mt-0 transition bg-white ease-in-out delay-150 border-[#ccc] truncate leading-[19.07px] text-gray-600 text-lg py-[8px] px-2 lg:pl-3 placeholder:text-base  rounded-md  focus:outline-none focus:border-blue-300"
                                  required
                                >
                                  <option value="">
                                    {t("usedCars.select.transmission")}
                                  </option>
                                  <option value="Automatic">
                                    {t("usedCars.options.transmission.automatic")}
                                  </option>
                                  <option value="Manual">
                                    {t("usedCars.options.transmission.manual")}
                                  </option>
                                </select> */}
                                        </div>
                                    </div>
                                    <InputFields
                                        type="number"
                                        title={t("usedCars.numberOfOwners")}
                                        placeholder={t(
                                            "usedCars.form.placeholders.numberOfOwners"
                                        )}
                                        value={formData?.overview?.numberOfOwners}
                                        name="overview.numberOfOwners"
                                        onChange={handleInputChange}
                                        min={1}
                                        step={1}
                                        onKeyDown={(e) => {
                                            if (e.code === "Minus") {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <div>
                                        <label className="mb-2 text-sm font-medium">
                                            {t("usedCars.labels.insuranceType")}
                                        </label>
                                        <div className="flex flex-row mt-1">
                                            <SelectBox
                                                options={[
                                                    { value: "Comprehensive", label: t("usedCars.options.insuranceType.comprehensive") },
                                                    { value: "Third-Party", label: t("usedCars.options.insuranceType.thirdParty") },
                                                ]}
                                                onChange={handleInputChange}
                                                value={formData?.overview?.insuranceType}
                                                placeholder={t("usedCars.select.insuranceType")}
                                                name="overview.insuranceType"
                                            />

                                        </div>
                                    </div>
                                    <InputFields
                                        type="text"
                                        title={t("usedCars.carModel")}
                                        placeholder={t("usedCars.form.placeholders.carModel")}
                                        value={formData?.overview?.carModel}
                                        name="overview.carModel"
                                        onChange={handleInputChange}
                                    />
                                    <InputFields
                                        type="text"
                                        title={t("usedCars.location")}
                                        placeholder={t("usedCars.form.placeholders.location")}
                                        value={formData?.overview?.location}
                                        name="overview.location"
                                        onChange={handleInputChange}
                                    />
                                    <div>
                                        <label className="mb-1 text-sm font-medium">
                                            {t("usedCars.labels.listingType")}
                                        </label>
                                        <div className="flex flex-row mt-1">
                                            <SelectBox
                                                options={[
                                                    { value: true, label: t("usedCars.options.listingType.public") },
                                                    { value: false, label: t("usedCars.options.listingType.private") },
                                                ]}
                                                onChange={handleInputChange}
                                                value={formData?.isPublic}
                                                placeholder={t("usedCars.select.listingType")}
                                                name="isPublic"
                                            />

                                        </div>
                                    </div>
                                    <div>
                                        <label className="mb-1 text-sm font-medium">
                                            {t("usedCars.labels.status")}
                                        </label>
                                        <div className="flex flex-row mt-1">
                                            <SelectBox
                                                options={[
                                                    { value: "available", label: t("usedCars.options.carStatus.available") },
                                                    { value: "on-hold", label: t("usedCars.options.carStatus.onHold") },
                                                ]}
                                                onChange={handleInputChange}
                                                value={formData?.status}
                                                placeholder={t("usedCars.select.carStatus")}
                                                name="status"
                                            />

                                        </div>
                                    </div>
                                    <div className="">
                                        <InputFields
                                            type="date"
                                            title={t("usedCars.insuranceValidity")}
                                            placeholder={t(
                                                "usedCars.form.placeholders.insuranceValidity"
                                            )}
                                            value={
                                                formData?.overview?.insuranceValidity?.split(
                                                    "T"
                                                )[0]
                                            }
                                            name="overview.insuranceValidity"
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="flex items-center my-4">
                                    <hr className="flex-grow border-t border-muted border-black" />
                                    <span className="mx-4 text-muted-foreground font-semibold text-xl">
                                        {t("usedCars.keySpecs")}
                                    </span>
                                    <hr className="flex-grow border-t border-muted border-black" />
                                </div>

                                <div className="grid grid-cols-3 gap-5 mt-5">
                                    <InputFields
                                        type="text"
                                        title={t("usedCars.engine")}
                                        placeholder={t("usedCars.form.placeholders.engine")}
                                        value={formData?.keySpecs?.engine}
                                        name="keySpecs.engine"
                                        onChange={handleInputChange}
                                    />
                                    <div className="">
                                        <label className="mb-2 text-sm font-medium">
                                            {t("usedCars.labels.colors")}
                                        </label>
                                        <CreatableSelect
                                            isMulti
                                            className="z-50"
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    minHeight: "49px",
                                                    height: "49px",
                                                    borderColor: "#ccc",
                                                    boxShadow: "none",
                                                    marginTop: "4px",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    padding: "0 8px",
                                                }),
                                            }}
                                            options={colorOptions}
                                            onChange={handleColorChange}
                                            value={formData?.keySpecs?.colors}
                                            placeholder={t(
                                                "usedCars.form.placeholders.selectColors"
                                            )}
                                        />
                                    </div>
                                    <InputFields
                                        type="text"
                                        title={t("usedCars.maxPower")}
                                        placeholder={t("usedCars.form.placeholders.maxPower")}
                                        value={formData?.keySpecs?.maxPower}
                                        name="keySpecs.maxPower"
                                        onChange={handleInputChange}
                                    />
                                    <InputFields
                                        type="text"
                                        title={t("usedCars.maxPowerRPM")}
                                        placeholder={t(
                                            "usedCars.form.placeholders.maxPowerRPM"
                                        )}
                                        value={formData?.keySpecs?.maxPowerRPM}
                                        name="keySpecs.maxPowerRPM"
                                        onChange={handleInputChange}
                                    />
                                    <InputFields
                                        type="text"
                                        title={t("usedCars.mileage")}
                                        placeholder={t("usedCars.form.placeholders.mileage")}
                                        value={formData?.keySpecs?.mileage}
                                        name="keySpecs.mileage"
                                        onChange={handleInputChange}
                                    />
                                    <InputFields
                                        type="number"
                                        title={t("usedCars.seatingCapacity")}
                                        placeholder={t(
                                            "usedCars.form.placeholders.seatingCapacity"
                                        )}
                                        value={formData?.keySpecs?.seatingCapacity}
                                        name="keySpecs.seatingCapacity"
                                        onChange={handleInputChange}
                                        min={0}
                                        step={1}
                                        onKeyDown={(e) => {
                                            if (e.code === "Minus") {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <div>
                                        <label className="mb-1 text-sm font-medium">
                                            {t("usedCars.labels.fuelType")}
                                        </label>
                                        <div className="flex flex-row mt-1">
                                            <SelectBox
                                                name="keySpecs.fuelType"
                                                value={formData?.keySpecs?.fuelType}
                                                onChange={handleInputChange}
                                                placeholder={t("usedCars.select.fuelType")}
                                                options={[
                                                    { value: "Petrol", label: t("usedCars.options.fuelType.petrol") },
                                                    { value: "Diesel", label: t("usedCars.options.fuelType.diesel") },
                                                    { value: "Electric", label: t("usedCars.options.fuelType.electric") },
                                                    { value: "Hybrid", label: t("usedCars.options.fuelType.hybrid") },
                                                ]}
                                                className="w-full"
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex justify-center mt-5">
                            <PrimaryButton
                                onClick={handleOnSUbmit}
                                title={edit ? t("usedCars.buttons.updateDetails") : t("usedCars.buttons.addUsedCar")}
                                loading={loading}
                            />
                        </div>
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    )
}

export default EditAddModal